module.exports = __webpack_public_path__ + "static/media/link.dada9769.2f8dab72.svg";